const EditorFromData = [{
		inputdata: "",
		title: "显示层级",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入显示层级",
		types: "number",
		inputtype: "input",
		width: "350px",
		lablewith: "80px",
	},
	{
		inputdata: "",
		title: "层级说明",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入层级说明",
		types: "text",
		inputtype: "input",
		width: "350px",
		lablewith: "80px",
	}
];
export default EditorFromData;